export default "__VITE_ASSET__7c10f882__"